// A Schlage site's default fob type. Mirrors ConnectApi's PhysicalKeyFobType
// (src/Livly.Connect.Models/Enums/Enums.cs) -- not yet in the NSwag-generated client.
// The 37-bit Brivo Unified Credential is always "BUC3_37Bit", never plain "BUC3".
export type DefaultFobType = "Schlage9000T" | "BUC3_37Bit";

export const DEFAULT_FOB_TYPE: DefaultFobType = "Schlage9000T";

export const DEFAULT_FOB_TYPE_OPTIONS: { value: DefaultFobType; label: string }[] = [
  { value: "Schlage9000T", label: "Schlage 9000T series" },
  { value: "BUC3_37Bit", label: "BUC3_37Bit (37-bit HID / Brivo Unified Credential)" },
];

export function fobTypeLabel(fobType: DefaultFobType): string {
  return DEFAULT_FOB_TYPE_OPTIONS.find((o) => o.value === fobType)?.label ?? fobType;
}
